<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                :caption="caption"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/user/list"
                :searchArgs="searchArgs"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/user"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'utilisateur')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet utilisateur?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../components/DynamicCardList'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'UserList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            caption: {
                type: String,
                default: 'Liste des utilisateurs'
            },
            parentId: {
                type: String | Number,
                default: ''
            }
        },
        mounted() {
            this.init()
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Avatar'),
                        key: 'avatar',
                        type: 'avatar',
                        sortable: true,
                        width: '70px',
                        defaultAvatar: 'default'
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'firstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom de famille'),
                        key: 'lastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Courriel'),
                        key: 'email',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Téléphone'),
                        key: 'phone',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Rôle'),
                        type: 'select',
                        key: 'userRole',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Parent'),
                        type: 'select',
                        key: 'userParentName',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'phone'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'branch'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'number',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'phone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'email',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'branch',
                            type: 'select',
                            multiple: false,
                            label: Core.Definition.getDefinition('Succursale'),
                            value: null,
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: Core.Session.AuthUser.can('user_management_put'),
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: Core.Session.AuthUser.can('user_management_delete'),
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            init() {
            },
            clickEdit(value, cell, row) {
                if (Core.Validation.isId(this.parentId)) {
                    this.$router.push('/systeme/utilisateurs/' + this.parentId + '/' + row.id)
                } else {
                    this.$router.push('/systeme/utilisateurs/' + row.id)
                }

            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
